/**
 * Enum for the different types of group by date available for widgets
 * @enum {string}
 * @readonly
 */
export const GroupDateTypes = Object.freeze({
  /** Years */
  YEARS: 'years',

  /** Months */
  MONTHS: 'months',

  /** Weeks */
  WEEKS: 'weeks',

  /** Days */
  DAYS: 'days'
});
